export default "__VITE_ASSET__X6m5xXal__"